import * as Globals from "../../globals";
import * as SceneManager from "../../sceneManager";
import {copyVectorArray, findChildrenByName} from "../../utils/threeUtils";
import {setObjectLayer} from "../../utils/layerUtils";
import {buildingGroup} from "../../main";
import {Box3, Vector3} from "three";
import {cutWallWithMesh} from "../walls/wall";
import {getOuterWallPoints} from "../../utils/wallAnalyzer";
import {recalculateVolumes} from "../../utils/volumeUtils";
import {createMeshFromPoints, pathPointsClockwise} from "../../utils/shapeUtils";
import * as nameConstants from "../../constants/nameConstants";
import {cutOutsGroupName} from "../../constants/nameConstants";
import {t} from "../../../i18n";

export class Roof {
    constructor(overhang, orientation, roofPoints = [], roofPointsObjects = []) {
        if (roofPoints.length === 0) {
            roofPoints = getOuterWallPoints(true);
            if (roofPoints.length < 4) {
                throw new Error(t("roof_no_outer_wall_manual"));
            }
            this.roofPoints = roofPoints;
            this.automaticRoof = true;
            this.roofPoints.push(this.roofPoints[0]);
        } else {
            this.roofPoints = roofPoints;
            this.roofPointObjects = roofPointsObjects;
            if (!pathPointsClockwise(this.roofPoints)) {
                this.roofPoints.reverse();
                this.roofPointObjects.reverse();
            }
            this.automaticRoof = false;
        }

/*         let box3 = new Box3();
        for (let i = 0; i < this.roofPoints.length; i++) {
            box3.expandByPoint(this.roofPoints[i]);
        }

        //console.log("before",this.roofPoints);
        const corners = [
            new Vector3(box3.min.x, roofPoints[0].y, box3.min.z), // Bottom-left
            new Vector3(box3.max.x, roofPoints[0].y, box3.min.z),  // Bottom-right
            new Vector3(box3.max.x, roofPoints[0].y, box3.max.z), // Top-right
            new Vector3(box3.min.x, roofPoints[0].y, box3.max.z), // Top-left
            new Vector3(box3.min.x, roofPoints[0].y, box3.min.z), // Bottom-left
        ];

        this.roofPoints = corners; */
        //console.log("after",this.roofPoints);


        this.previewShape = createMeshFromPoints(this.roofPoints);
        this.orientation = orientation;
        this.overhang = overhang;
        this.thickness = Globals.HBEWallDefaultThickness; //Default Dicke für die Konstruktion der temporären Dächer. Tatsächliche Stärke wird später kalkuliert.
    }

    static extendRoofPointsByLength(roofPoints, isClockwise, extendLength) {
        roofPoints = copyVectorArray(roofPoints);
        let roofPointsAngleCopy = copyVectorArray(roofPoints);
        let axis = new Vector3(0, 1, 0);
        let angle = isClockwise ? Math.PI / 2 : -Math.PI / 2;

        for (let i = 0; i < roofPoints.length - 1; i++) {
            let p0 = roofPointsAngleCopy[i];
            let p1 = i !== roofPointsAngleCopy.length - 2 ? roofPointsAngleCopy[i + 1] : roofPointsAngleCopy[0];

            let vector = new Vector3(p1.x - p0.x, 0, p1.z - p0.z);
            vector.applyAxisAngle(axis, angle);
            vector.clampLength(extendLength, extendLength);
            roofPoints[i].add(vector);
            roofPoints[i + 1].add(vector);
            if (i === 0) {
                roofPoints[roofPoints.length - 1].add(vector);
            } else if (i === roofPoints.length - 2) {
                roofPoints[0].add(vector);
            }
        }

        return roofPoints;
    }

    create() {

    }

    cutRoofElementsToShape(roof, cutMesh) {
        let roofElements = [];
        for (let i = 0; i < roof.children.length; i++) {
            if (roof.children[i].name === cutOutsGroupName) {
                continue;
            }
            roofElements.push(roof.children[i]);
        }

        cutWallWithMesh(roofElements, cutMesh, true, true, false);
        recalculateVolumes(roofElements);
        setObjectLayer(roof, Globals.layers.roof, true);
    }

    getRoofHeight() {
        return this.roofPoints[0].y; //TODO: Roof Thickness auslesen
    }
}

export function deleteRoof(roofGroup) {
    let wallGroups = findChildrenByName(buildingGroup, nameConstants.wallGroupName, false, true, 2);
    SceneManager.clearGroup(roofGroup);
    roofGroup.removeFromParent();
    for (let i = 0; i < wallGroups.length; i++) {
        let wallGroup = wallGroups[i];
        if (wallGroup.userData.roof !== undefined) {
            delete wallGroup.userData.roof;
        }
    }
}

export function checkForRoofCreation(){
    let points = getOuterWallPoints(true);
    return points.length >= 4;
}
